// extracted by mini-css-extract-plugin
module.exports = {"Card":"Signup_Card__1uDFC","dividertext":"Signup_dividertext__MkBsy","btnfacebook":"Signup_btnfacebook__2Yqcd","btntwitter":"Signup_btntwitter__3x9og"};